import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {AutocompleteModule} from '@share/component/autocomplete/autocomplete.module';
import {GeographieSelectionPopinComponent} from './geographie-selection-popin.component';

@NgModule({
    declarations: [GeographieSelectionPopinComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        AutocompleteModule
    ],
    exports: [GeographieSelectionPopinComponent]
})
export class GeographieSelectionPopinModule {}